import { render, staticRenderFns } from "./orderShopee.vue?vue&type=template&id=8e522cac&scoped=true"
import script from "./orderShopee.vue?vue&type=script&lang=js"
export * from "./orderShopee.vue?vue&type=script&lang=js"
import style0 from "./orderShopee.vue?vue&type=style&index=0&id=8e522cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e522cac",
  null
  
)

export default component.exports